import React from 'react'
export interface ContextType {
  selectedItemSidebar: string
  setSelectedItemSidebar: (selectedItem: string) => void
}
export const SidebarContext = React.createContext<ContextType | null>(null)
